import { z } from 'zod';

export type BreadcrumbDTO = z.infer<typeof BreadcrumbDTO>;
export const BreadcrumbDTO = z.object({
    id: z.string(),
    label: z.string(),
    link: z.string(),
    tcDisplayName: z.string().optional(),
});
